export  function PrivacyPolicy() {
  return (
    <div className="PrivacyPolicy_container">
      <h1>Privacy Policy</h1>
    </div>
  )
}
